@let componentId = feeWaiver().billingFeeWaiverGroupId ? feeWaiver().billingFeeWaiverGroupId : feeWaiver().feeWaiverId;

<p-chip
    [id]="'fee-waiver-tag-' + componentId"
    [removable]="isRemovable()"
    [class]="'waiver-tag'"
    [class.display-interval]="displayInterval()"
    [class.cursor-pointer]="enableAuditLog()"
    [ngClass]="sizeClass()"
    [style.backgroundColor]="feeWaiverTagColor() + '!important'"
    [style.color]="'#000'"
    (click)="handleClickEvent($event)"
    (onRemove)="onRemove.emit(feeWaiver().feeWaiverId)">
    <span ellipsis-tooltip class="name">
        {{ feeWaiver().name }}
    </span>
    @if (displayInterval()) {
        <span class="interval-info">
            {{
                feeWaiver().startDate +
                    (feeWaiver().startDate !== feeWaiver().endDate ? ' - ' + feeWaiver().endDate : '')
            }}
        </span>
    }
</p-chip>
